<div style="width: 100%; height: 100%;" class="flex center">
    <div #loadingOverlayPage class="overlayPage flex center" [class.hidden]="isHidden$.value">
        <app-spinner></app-spinner>
    </div>
</div>
